export default __webpack_public_path__ + "static/media/CV.040fb64f.pdf";